/**
 * Checkout's grid, shared by the page and its pending skeleton so the two
 * cannot drift.
 *
 * Two columns — options left, summary right, as `4243:76407` draws them —
 * only on a desktop viewport AND a wide enough main column: `lg:` alone would
 * squeeze both columns beside the Mitra panel, `@2xl` alone would split a
 * tablet's column in two. Stacked, the summary comes after the options. The
 * left column is its own container, so "How often" and "How you pay" sit
 * side by side wherever it is wide enough, in either layout.
 */
export const CHECKOUT_COLUMNS = 'grid items-start gap-6 lg:@2xl:grid-cols-2'
export const OPTIONS_COLUMN = '@container/options flex min-w-0 flex-col gap-4'
export const OPTIONS_PAIR = 'grid gap-4 @lg/options:grid-cols-2'

/**
 * A checkout option group's card (mock `su-opts`): the surface fill, 12 16 8 in, full height so
 * the pair lines up; its 12/600 head in the tertiary ink.
 */
export const OPTION_GROUP = 'h-full min-w-0 bg-card px-4 pt-3 pb-2'
export const OPTION_LEGEND = 'text-h-xs text-muted-foreground-subtle'
